export const incomeCategoryList = [
  {
    key: 1,
    Code: "INCA849",
    Category: "Foreign investment",
    Added_Date: "24 Dec 2024",
  },
  {
    key: 2,
    Code: "INCA48",
    Category: "Product Export",
    Added_Date: "10 Dec 2024",
  },
  {
    key: 3,
    Code: "INCA47",
    Category: "Installation",
    Added_Date: "27 Nov 2024",
  },
  {
    key: 4,
    Code: "INCA46",
    Category: "Product Sales",
    Added_Date: "18 Nov 2024",
  },
  {
    key: 5,
    Code: "IN845",
    Category: "Local Sale",
    Added_Date: "06 Nov 2024",
  },
  {
    key: 6,
    Code: "INCA44",
    Category: "Service Fees",
    Added_Date: "25 Oct 2024",
  },
  {
    key: 7,
    Code: "INCA843",
    Category: "Return/Refund Income",
    Added_Date: "14 Oct 2024",
  },
  {
    key: 8,
    Code: "INCA842",
    Category: "Foreign investment",
    Added_Date: "03 Oct 2024",
  },
  {
    key: 9,
    Code: "INCA841",
    Category: "Product Export",
    Added_Date: "20 Sep 2024",
  },
  {
    key: 10,
    Code: "INCA840",
    Category: "Return/Refund Income",
    Added_Date: "10 Sep 2024",
  },
];
